export interface FileValidationConfig {
  allowedTypes: readonly string[];
}

export interface FileValidationResult {
  isValid: boolean;
  error?: 'INVALID_TYPE' | 'NO_FILE';
  message?: string;
}

export function validateFile(
  file: File | null,
  config: FileValidationConfig
): FileValidationResult {
  if (!file) {
    return {
      isValid: false,
      error: 'NO_FILE',
      message: 'No file selected'
    };
  }

  // Check file type
  const fileExtension = file.name.split('.').pop()?.toLowerCase();
  const allowedExtensions = config.allowedTypes.map((type) =>
    type.toLowerCase()
  );

  if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
    return {
      isValid: false,
      error: 'INVALID_TYPE',
      message: `File type not supported. Please upload a ${config.allowedTypes
        .map((type) => type.toUpperCase())
        .slice(0, -1)
        .join(', ')} or ${config.allowedTypes[
        config.allowedTypes.length - 1
      ].toUpperCase()} file.`
    };
  }

  return {
    isValid: true
  };
}

// Predefined configurations for common use cases
export const FILE_VALIDATION_CONFIGS = {
  IMAGES_ONLY: {
    allowedTypes: ['jpg', 'jpeg', 'png']
  },
  PDF_ONLY: {
    allowedTypes: ['pdf']
  },
  DOCUMENTS: {
    allowedTypes: ['jpg', 'jpeg', 'png', 'pdf']
  },
  BANK_STATEMENT: {
    allowedTypes: ['jpg', 'jpeg', 'png', 'pdf']
  }
} as const;

export const isPDF = (file: File) => {
  return validateFile(file, FILE_VALIDATION_CONFIGS.PDF_ONLY).isValid;
}
